<template lang="pug">
.content.has-text-centered
  h1.is-title.is-bold Login
  .columns.is-vcentered
    .column.is-6.is-offset-3
      .box
        div(v-show='error' style='color:red; word-wrap:break-word;') {{ error }}
        form(v-on:submit.prevent='login')
          label.label Email
          p.control
            input.input(v-model='username' type='text' placeholder='email@example.org')
          label.label Password
          p.control
            input.input(v-model='password' type='password' placeholder='password')
          p.control
            label.checkbox(disabled)
              input(type='checkbox' v-model='rememberMe' disabled)
              |
              | Remember me
          hr
          p.control
            button.button.is-primary(type='submit') Login
            router-link.button.is-default(to='Home') Cancel
</template>

<script>
export default {
  data () {
    return {
      username: null,
      password: null,
      rememberMe: false,
      error: null,
      waiting: false
    }
  },
  methods: {
    login () {
      this.waiting = true
      this.$store.dispatch('auth/login', {
        username: this.username,
        password: this.password,
        rememberMe: this.rememberMe,
        callback: (res) => {
          this.waiting = false
          if (res.status === 200) {
            this.$router.push(this.$route.query.redirect || 'Home')
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.is-title {
    text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// Login.vue?5043463c